import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadcrumbItem { label: string; route?: string; }

@Component({
    selector: 'app-breadcrumb-bar',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
    <nav *ngIf="items.length > 1" class="breadcrumb-bar" aria-label="Breadcrumb">
      <ng-container *ngFor="let item of items; let last = last">
        <a *ngIf="item.route && !last" [routerLink]="item.route" class="bc-link">{{ item.label }}</a>
        <span *ngIf="!item.route || last" class="bc-current">{{ item.label }}</span>
        <span *ngIf="!last" class="bc-sep">›</span>
      </ng-container>
    </nav>
  `,
    styles: [`
    .breadcrumb-bar {
      display: flex;
      align-items: center;
      gap: 0.35rem;
      padding: 0.5rem 1.5rem;
      background: var(--surface-section, #f5f5f5);
      border-bottom: 1px solid var(--surface-border, #e0e0e0);
      font-size: 0.8125rem;
      position: sticky;
      top: 0;
      z-index: 10;
    }
    .bc-link { color: var(--primary-color); text-decoration: none; }
    .bc-link:hover { text-decoration: underline; }
    .bc-current { color: var(--text-color-secondary); font-weight: 600; }
    .bc-sep { color: var(--text-color-secondary); opacity: 0.5; }
  `]
})
export class BreadcrumbBarComponent {
  @Input() items: BreadcrumbItem[] = [];
}
